import { type RouteObject } from 'react-router-dom';

import { AuthorizedOutlet } from '@myphx-engineering/auth/client';

import routes from '../app-routes';

import { CabinetHistoryRoute } from './CabinetHistoryRoute';
import { CabinetRoute } from './CabinetRoute';
import patientRoutes from './patient';
import prescriptionRoutes from './prescription';

const cabinetRoutes: RouteObject[] = [
    {
        path: routes.cabinet.root,
        element: <AuthorizedOutlet />,
        children: [
            {
                index: true,
                element: <CabinetRoute />,
            },
            {
                path: routes.cabinet.history,
                element: <CabinetHistoryRoute />,
            },
            ...patientRoutes,
            ...prescriptionRoutes,
        ],
    },
];

export default cabinetRoutes;
